import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
import Button from '../../../BaseModule/Components/Button';
import { Size } from '../../../../Enums/Size.enum';
import { useUserSubscriptionCancelMutation } from '../../../../graphql/graphql';
// @ts-ignore
import styles from './SubscriptionCancellationModal.module.scss';

interface Props extends BaseModalProps {
	subscriptionId: string;
	onSuccessfulCancellation: () => void;
}

const SubscriptionCancellationConfirmationModal: React.FC<Props> = props => {
	const { onClose, onSuccessfulCancellation, subscriptionId } = props;
	const [cancelSubscription] = useUserSubscriptionCancelMutation();

	const handleCancelSubscription = async () => {
		const result = await cancelSubscription({
			input: { id: subscriptionId },
		}).unwrap();

		if (result?.userSubscriptionCancel?.status) {
			onSuccessfulCancellation();
		}
	};

	return (
		<BaseModal
			{...props}
			title='component.subscriptionCancellationConfirmationModal.title'
			size={Size.SM}
		>
			<div className={styles.wrapper}>
				<div className='d-flex flex-column justify-content-center align-items-center gap-2'>
					<Button
						text='component.subscriptionCancellationConfirmationModal.cancel'
						onClick={onClose}
					/>
					<Button
						text='component.subscriptionCancellationConfirmationModal.confirm'
						onClick={handleCancelSubscription}
						className='light'
					/>
				</div>
			</div>
		</BaseModal>
	);
};
export default SubscriptionCancellationConfirmationModal;
